<template lang="pug">
app-page(:fab-items="fabItems" title="Мои дела")
  v-container(fluid p-0)
    v-layout
      app-toolbar(:title="`Дело № ${ caseNumber }`" back)
            
    v-layout(align-start justify-center)
      v-flex(lg8 light)
        app-sublayer
          app-sublayer-header Создать профиль стророны по делу
          .member-form
            div {{ tabs }} 
            v-tabs.tabs(v-model="tabs" background-color="#F0F0F0" height="40" slider-color="#00BCD4" slider-size="4" active-class="tabs__item--active" light)
              v-tab.tabs__item.text-none.px-0.ml-4(:disabled="member && member.persona.personaType.name != 'FL'") Физическое лицо
              v-tab.tabs__item.text-none.px-0.ml-6(:disabled="member && member.persona.personaType.name != 'UL'") Юридическое лицо
              v-tab.tabs__item.text-none.px-0.ml-6(:disabled="member && member.persona.personaType.name != 'DL'") Должностное лицо
            
            v-form.pa-4(v-model="valid" ref="formMember" light)
              v-tabs-items(v-model="tabs" light)
                // Individual
                v-tab-item
                  app-text-field(v-model="form.persona.name" label="ФИО" :rules="[requireFL]")
                  // app-date-picker(v-model="form.persona.birthDate" label="Дата рождения" view-format="DD.MM.YYYY" :rules="tabs == 0 ? [rules.required] : []" :max="getISOToday")
                  app-text-field(v-model="viewBirthDate" label="Дата рождения" :rules="tabs == 0 ? [requireFL, rules.rudate] : []" v-mask="mask.date")

                // Legal
                v-tab-item
                  app-text-field(v-model="form.persona.orgName" label="Наименование" :rules="[requireUL]")
                  app-text-field(v-model="form.persona.orgINN" label="ИНН" :rules="[requireUL]")
                  app-text-field(v-model="form.persona.orgKPP" label="КПП" :rules="[requireUL]")
                  app-text-field(v-model="form.persona.name" label="ФИО представителя" :rules="[requireUL]")
                
                // Official
                v-tab-item
                  app-text-field(v-model="form.persona.name" label="ФИО" :rules="[requireDL]")

              app-select(v-model="form.status" :items="memberStatuses" :rules="[rules.required]" label="Статус" item-text="title")
              //- Маска не работает - валиться ошибка
              //- CaseMemberDatabox(v-model="phoneItems" label="Телефон" data-type="PHONE" v-mask="mask.phone")
              
              CaseMemberDatabox(v-model="phoneItems" label="Телефон" data-type="PHONE")
              CaseMemberDatabox(v-model="emailItems" label="Email" data-type="EMAIL" :rules="[rules.emailcombo]")
              CaseMemberDatabox(v-model="addressItems" label="Адрес" data-type="ADDRESS")
            
              app-textarea(v-model="form.persona.personaComments[0].comment" label="Комментарий")
          .pt-4.text-right
            app-button-cancel.mr-2(@click="goBack") Отмена
            app-button-action(@click="editMember") Сохранить

</template>

<script>
import { AppDialogToggable } from '@/components'
import { memberType } from './components/constants.js'
import { mapGetters } from 'vuex'
import { memberService } from "@/_services"
import { $_validate_rules } from '@/common/ValidateRules'
import moment, { $_app_moment, $_app_moment_format as DateFormat } from "@/common/AppMoment.js"

import { mask } from 'vue-the-mask' 

import CaseMemberDatabox from "./components/CaseMemberDatabox";

export default {
  mixins: [AppDialogToggable, $_validate_rules, $_app_moment],
  directives: { mask },
  components: { CaseMemberDatabox },

  props: {
    caseId: null,
    memberId: null,
    type: {
      type: Number,
      default: memberType.individual
    }
  },

  watch: {
    member () {
      this.updateForm()
    }
  },

  mounted() {
    this.$store.dispatch('courtCase/MEMBER_INIT', { caseId: this.caseId })
    this.updateForm()
  },

  data () {
    const defaultForm = Object.freeze({
      status: '',
      persona: { 
        name: '',
        birthDate: '',
        orgName: '',
        orgINN: '',
        orgKPP: '',
        note: '',
        personaData: [],
        personaType: {
          name: 'FL'
        },
        personaComments: [{ comment: ""}]
      },
    })

    return {
      mask: {
        phone: '+7 (###) ### ####',
        date: '##.##.####'
      },

      valid: true,
      tabs: null,

      emailItems: [],
      phoneItems: [],
      addressItems: [],

      viewBirthDate: '',

      comment: null,

      form: Object.assign({}, defaultForm),
      memberType,
      defaultForm, 
    }
  },

  computed: {
    ...mapGetters('courtCase', ['memberStatuses', 'caseNumber', 'members']),

    member () {
      return this.members.find(m => m.id == this.memberId)
    },

    isNotReady () {
      if (!this.form.persona.name) return true
      if (this.tabs == 1 && ( !this.form.persona.orgName || !this.form.persona.orgINN || !this.form.persona.orgKPP )) return true
      if (this.addressItems.length == 0 || this.phoneItems.length == 0 || this.emailItems.length == 0) return true
      if (!this.form.status) return true
      return false
    },

    fabItems: () => [],

    requireFL () {
      return this.tabs == 0 ? this.rules.required : true
    },

    requireUL () {
      return this.tabs == 1 ? this.rules.required : true
    },

    requireDL () {
      return this.tabs == 2 ? this.rules.required : true
    }
  },

  methods: {
    goBack () {
      this.$router.push({ path: `/case/${this.caseId}` })
    },

    updateForm () {
      let baseObj = this.member || this.defaultForm
      this.form = JSON.parse(JSON.stringify(baseObj))

      let personData = this.form.persona.personaData
      this.phoneItems = personData.filter(item => item.dataType.name === 'PHONE')
      this.emailItems = personData.filter(item => item.dataType.name === 'EMAIL')
      this.addressItems = personData.filter(item => item.dataType.name === 'ADDRESS')

      this.viewBirthDate = this.form.persona.birthDate ? moment(this.form.persona.birthDate, DateFormat.save).format(DateFormat.view) : ''

      this.tabs = this.member && this.member.persona.personaType.name === 'UL' ? 1 : this.member && this.member.persona.personaType.name === 'DL' ? 2 : 0
      if (this.form.persona.personaComments.length == 0) this.form.persona.personaComments = [{ comment: '' }]
    },

    editMember () {
      if (this.$refs.formMember.validate()) {
        let otherData = this.form.persona.personaData.filter(obj => obj.dataType.name !== 'ADDRESS' && obj.dataType.name !== 'EMAIL' && obj.dataType.name !== 'PHONE')
        this.form.persona.personaData = otherData.concat(this.emailItems, this.addressItems, this.phoneItems)
        this.form.persona.personaType = this.member ? this.member.persona.personaType.name : this.tabs == 1 ? 'UL' : this.tabs == 2 ? 'DL' : 'FL'
        this.form.persona.birthDate = this.viewBirthDate ? moment(this.viewBirthDate, DateFormat.view).format(DateFormat.save)+ ' 00:00' : ''

        this.member ? this.updateMember() : this.createMember()
      }
    },

    createMember () {
      memberService.create(this.caseId, this.form)
      .then(() => {
        this.$store.dispatch('courtCase/LOAD_CASE', this.caseId)
        this.goBack()
      })
    },
    
    updateMember() {
      memberService.update(this.form)
      .then(() => {
        this.$store.dispatch('courtCase/LOAD_CASE', this.caseId)
        this.goBack()
      })
    },

    updateEditedPerson() {
      let personaData = this.editMember.persona.personaData.map((value) => {
        value.dataType = value.dataType.name
        return value
      })
      this.editMember.persona.personaData = personaData

      memberService.updatePersona(  this.editMember.persona )
      .then(() => {
        this.modals.user.edit.notice = false
        this.currentMember = null
        this.loadCase()
      })
    },
  }
}
</script>

<style>
.tabs__item--active {
  color: #00BCD4 !important;
}
</style>

<style lang="scss" scoped>
.tabs__item {
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 20px;
}
.member-form {
  background: #FFFFFF;
  border-radius: 5px;
  overflow: hidden;
}
</style>